import Link from 'next/link';

type LinkProps = {
  href?: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
};

const CustomLink = ({ href, children, className, target, rel, onClick }: LinkProps) => {
  if (!href) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Link href={href} className={className} target={target} rel={rel} onClick={onClick}>
      {children}
    </Link>
  );
};

export default CustomLink;
